import {useTheme} from '@mui/material';
import {css} from '@emotion/css';
import {PAPER_BORDER} from '../ThemeProvider';

export function useGlassBarClass() {
	const theme = useTheme();
	return css`
		background-image: none;
		background-color: ${theme.palette.mode === 'dark' ? 'rgba(40, 40, 40, 0.8)' : 'hsla(0, 0%, 100%, 0.45)'};
		border: ${PAPER_BORDER[theme.palette.mode]};
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		border-radius: ${theme.shape.borderRadius * 6}px;
		overflow: hidden;
	`;
}
